import {Nullable} from '../../app/TypeHelpers'

export default class UpdateEquipment {
    name: string
    explainText: string
    parentEquipmentId: Nullable<number>
    reservationCountMonthly: Nullable<number>
    reservationCountDaily: Nullable<number>
    lotteryEntryCountMonthly: Nullable<number>
    version: number

    constructor(
        name: string,
        explainText: string,
        parentEquipmentId: Nullable<number>,
        reservationCountMonthly: Nullable<number>,
        reservationCountDaily: Nullable<number>,
        lotteryEntryCountMonthly: Nullable<number>,
        version: number,
    ) {
        this.name = name
        this.explainText = explainText
        this.parentEquipmentId = parentEquipmentId
        this.reservationCountMonthly = reservationCountMonthly
        this.reservationCountDaily = reservationCountDaily
        this.lotteryEntryCountMonthly = lotteryEntryCountMonthly
        this.version = version
    }

    static from(json: any): UpdateEquipment {
        return new UpdateEquipment(
            json.name,
            json.explainText,
            json.parentEquipmentId,
            json.reservationCountMonthly,
            json.reservationCountDaily,
            json.lotteryEntryCountMonthly,
            json.version,
        )
    }
}
